import { render, staticRenderFns } from "./PlanetPressConnect.vue?vue&type=template&id=25ba37b6&scoped=true&"
import script from "./PlanetPressConnect.vue?vue&type=script&lang=js&"
export * from "./PlanetPressConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba37b6",
  null
  
)

export default component.exports